import { useI18n } from "@core/i18n/i18n";
import { useFormatFeedback } from "@domain/progress/hooks/use-feedback";
import { exertionValues } from "@domain/progress/patient-feedback";
import styled from "@emotion/styled";
import { Button } from "@ui/components/buttons/button";
import { BaseDialog, DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { row } from "@ui/style";
import { DialogProps } from "primereact/dialog";
import React from "react";

export type ExertionDetailsDialogProps = DialogProps;

export const ExertionDetailsDialog: React.FC<ExertionDetailsDialogProps> = props => {
	const { format } = useI18n();
	const { formatExertion } = useFormatFeedback();

	return (
		<BaseDialog
			dismissableMask
			{...props}
			header={format("patientDetails.progress.exertionModal.title")}
			footer={
				<ButtonContainer>
					<Button onClick={props.onHide} label={format("patientDetails.progress.exertionModal.button")} />
				</ButtonContainer>
			}
			width={DIALOG_SIZE.M}
		>
			<DialogMessage style={{ whiteSpace: "pre-line" }}>
				{format("patientDetails.progress.exertionModal.description.v1_6")}
			</DialogMessage>
			<DialogMessage style={{ whiteSpace: "pre-line" }}>
				{exertionValues.map(v => {
					const exertionWording = formatExertion(v);
					return (
						<div key={v}>{format("patientDetails.progress.exertionModal.exertionListing.v1_6", exertionWording)}</div>
					);
				})}
			</DialogMessage>
		</BaseDialog>
	);
};

const DialogMessage = styled.div`
	margin: 0;
`;

const ButtonContainer = styled.div`
	${row(24, "flexend")}
`;
